module.exports = __webpack_public_path__ + "static/icon_color_walking_nag-d8969f61861c6da6edcbe4f665d26c95.png";